export default class Toggle {

    constructor(options){
        if( typeof options.items === 'string' ) {
            options.items = document.querySelectorAll(options.items);
        }
        this.options = options;
        this.items = options.items;
        this.init();
    }

    init(){
        this.items.forEach(item=>{
            const trigger = item.querySelector(this.options.trigger);
            // const content = item.querySelector(this.options.content);
            trigger.addEventListener('click',()=>{
                item.classList.toggle('open')
            })
        })
    }
}